import { Form, Input, Modal, Space, Typography } from "@payping/web-components";
import { setShowTOTPModal, setTOTPCode } from "@payping/redux/actions";
import { Key, Mail, Password } from "@payping/icons";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { apiConfigs } from "@payping/api";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useNavigate } from "react-router-dom";
import { webConstants } from "@payping/utils/platformConstants";

export const TOTPModal = () => {
  const [form] = Form.useForm();
  const { TOTPCode, showTOTPModal } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const phoneNumber = useAppSelector((state) => state.user.personalInfo?.phoneNumber);
  const navigate = useNavigate();

  function hideMiddleDigits(phone?: string | number) {
    const string = String(phone);
    return `${string.substring(8)}****${string.substring(0, 4)}`;
  }
  const hiddenPhoneNumber = hideMiddleDigits(phoneNumber);
  const { t } = useAppTranslation();

  useEffect(() => {
    apiConfigs.updateConfig({ totpCode: TOTPCode });
  }, [TOTPCode]);

  return (
    <Modal
      zIndex={1010}
      title={t("user.2fa.modal.sms2faTitle")}
      open={showTOTPModal}
      okText={t("common.submit")}
      onOk={async () => {
        form.submit();
      }}
      cancelText={t("back")}
      onCancel={async () => {
        await dispatch(setShowTOTPModal(false));
        navigate(webConstants.DashboardRoutes.home.overview);
      }}
    >
      <Space size={"large"}>
        <Password className={"color--gray500"} width={"64px"} />
        <Mail strokeWidth={"0.6px"} className={"color--gray500"} width={"64px"} />
      </Space>
      <Space direction={"vertical"}>
        <Typography.Text type={"secondary"}>{t("user.2fa.modal.smsCodeDesc", { hiddenPhoneNumber })}</Typography.Text>
        <Form
          form={form}
          onFinish={async (values) => {
            apiConfigs.updateConfig({ totpCode: values.totpCode });
            await dispatch(setTOTPCode(values.totpCode));
            await dispatch(setShowTOTPModal(false));
          }}
          layout={"vertical"}
        >
          <Form.Item
            label={t("user.2fa.modal.code")}
            name="totpCode"
            rules={[
              {
                required: true,
                validator: (_, value): Promise<void> =>
                  value && value === TOTPCode ? Promise.reject(new Error(t("error.duplicateCode"))) : Promise.resolve(),
              },
            ]}
          >
            <Input.Password addonBefore={<Key width={"14px"} />} />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  );
};
